"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestFinish = void 0;
var getProgress_1 = require("./getProgress");
exports.requestFinish = function (state, request) {
    var index = state.activeRequests.indexOf(request);
    var activeRequests = __spreadArrays(state.activeRequests);
    if (index !== -1) {
        activeRequests.splice(index, 1);
    }
    var progress = getProgress_1.getProgress(state.total, activeRequests);
    var active = activeRequests.length > 0;
    var total = active ? state.total : 0;
    return {
        active: active,
        activeRequests: activeRequests,
        progress: progress,
        total: total
    };
};
